<template>
  <div>
    <div
      v-if="isDeveloper"/>
    <EditLotGroup
      v-if="isGroupLotsEnabled"
      :rules="rules"
      :tender="tender"
      @startValidate="$emit('startValidate')"
      @update:rules="$emit('update:rules', $event)"
      @update:tender="$emit('update:tender', $event)">
      <template #title>
        <slot name="title"/>
      </template>
    </EditLotGroup>
    <EditLot
      v-else
      :rules="rules"
      :tender="tender"
      @startValidate="$emit('startValidate')"
      @update:rules="$emit('update:rules', $event)"
      @update:tender="$emit('update:tender', $event)">
      <template #title>
        <slot name="title"/>
      </template>
    </EditLot>
  </div>
</template>
<script>
import EditLotGroup from 'components/tenderCreation/block/EditLotGroup.vue'
import EditLot from 'components/tenderCreation/block/EditLot.vue'

import tenderLotsBaseMixin from 'mixins/tenderLotsBaseMixin.js'

export default {
  name: 'TenderLots',
  mixins: [tenderLotsBaseMixin],
  components: {
    EditLotGroup,
    EditLot,
  },
}
</script>
